import { useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import CAREPLAN from 'apollo/queries/CAREPLAN'
import { safeRunMutation } from 'utils/mutations'

// UPDATE_CAREPLAN_ENTITY

const mutation = gql`
  mutation updateRoadmapEntity(
    $entity_id: ID!
    $roadmap_id: ID!
    $entity_type: ROADMAP_ENTITY_SOURCE_TYPE!
    $attributes: RoadmapEntityAttributesInput!
  ) {
    updateRoadmapEntity(
      entity_id: $entity_id
      roadmap_id: $roadmap_id
      entity_type: $entity_type
      attributes: $attributes
    ) {
      id
    }
  }
`

export default function useUpdateRoadmapEntity(
  successMessage = 'Provider/Facility updated'
) {
  const [carePlanLoading, setCarePlanLoading] = useState(false)
  const [mutate, { loading }] = useMutation(mutation, {
    refetchQueries: [CAREPLAN],
    onQueryUpdated: observableQuery => {
      setCarePlanLoading(true)
      observableQuery.refetch().finally(() => setCarePlanLoading(false))
      return false
    }
  })

  const onUpdateRoadmapEntity = async ({
    entity_id,
    roadmap_id,
    entity_type,
    attributes
  }) => {
    const payload = {
      entity_id,
      roadmap_id,
      entity_type,
      attributes
    }

    const { r, isErrorFree } = await safeRunMutation({
      mutate,
      payload,
      successMessage,
      responsePath: 'updateRoadmapEntity'
    })
    return { r, isErrorFree }
  }

  return { onUpdateRoadmapEntity, loading, carePlanLoading }
}
